import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import {
  buildFolderPlayHref,
  startFolderPlay,
} from '@/shared/features/quiz-folder';

/**
 * 번역 없이 원문으로 재생한다.
 *
 * `language` 는 화면 로케일이 아니라 퀴즈를 번역해 재생할 언어다. 로케일을 그대로 넘기면
 * 준비되지 않은 언어라 `INVALID_TRANSLATION_LANGUAGE` 400 이 난다.
 */
const NO_TRANSLATION = 'default';

/**
 * 폴더의 첫 퀴즈로 입장한다. 목적지는 일반 퀴즈 입장과 같은 `/play/{entryMapHashId}` 다.
 *
 * `folderId` 를 쿼리로 실어 보낸다 — 서버가 재생 커서를 들고 있지 않아 `/play` 는 폴더 재생 여부를 URL 로만
 * 안다.
 * 실패는 호출부(`useFolderCta`)가 기록한다. 전역 처리기는 인증 실패만 다룬다.
 */
export const useFolderPlay = (folderId: string) => {
  const router = useRouter();

  return useMutation({
    mutationFn: () => startFolderPlay(folderId, NO_TRANSLATION),
    onSuccess: res =>
      router.push(
        buildFolderPlayHref({
          folderId: res.quizsetFolderId,
          entryMapHashId: res.launch.entryMapHashId,
        }),
      ),
  });
};
